import { render, staticRenderFns } from "./InstructionsScreen.vue?vue&type=template&id=5a4e51dc&scoped=true&lang=pug"
import script from "./InstructionsScreen.vue?vue&type=script&lang=ts"
export * from "./InstructionsScreen.vue?vue&type=script&lang=ts"
import style0 from "./InstructionsScreen.vue?vue&type=style&index=0&id=5a4e51dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4e51dc",
  null
  
)

export default component.exports